export const vaildte = {
	/**
	 * @description 判读是否为外链
	 * @param path
	 * @returns {boolean}
	 */
	isExternal: function(path) {
		return /^(https?:|mailto:|tel:|\/\/)/.test(path)
	},

	/**
	 * @description 校验密码是否小于6位
	 * @param value
	 * @returns {boolean}
	 */
	isPassword: function(value) {
		return value.length >= 6
	},

	/**
	 *@description 校验密码是否小于6位,至少一个数字和一个字母
	 *@param password
	 *@param length 长度
	 *@returns {boolean}
	 */
	CheckPassWord: function(password, length) { //密码必须包含数字和字母
		let str = password;
		if (str == null || str.length < length) {
			return false;
		}
		let reg = new RegExp(/^(?![^a-zA-Z]+$)(?!\D+$)/);
		if (reg.test(str))
			return true;
	},


	/**
	 * @description 判断是否为数字
	 * @param value
	 * @returns {boolean}
	 */
	isNumber: function(value) {
		const reg = /^[0-9]*$/
		return reg.test(value)
	},

	/**
	 * @description 判断是否是名称
	 * @param value
	 * @returns {boolean}
	 */
	isName: function(value) {
		const reg = /^[\u4E00-\u9FA5\uf900-\ufa2d]{1,10}[\·]{0,1}[\u4E00-\u9FA5\uf900-\ufa2d]{1,10}$/;// eslint-disable-line
		return reg.test(value)
	},

	/**
	 * @description 判断是否为IP
	 * @param ip
	 * @returns {boolean}
	 */
	isIP: function(ip) {
		const reg =
			/^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/
		return reg.test(ip)
	},

	/**
	 * @description 判断是否是传统网站
	 * @param url
	 * @returns {boolean}
	 */
	isUrl: function(url) {
		const reg =
			/^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
		return reg.test(url)
	},

	/**
	 * @description 判断是否是小写字母
	 * @param value
	 * @returns {boolean}
	 */
	isLowerCase: function(value) {
		const reg = /^[a-z]+$/
		return reg.test(value)
	},

	/**
	 * @description 判断是否是大写字母
	 * @param value
	 * @returns {boolean}
	 */
	isUpperCase: function(value) {
		const reg = /^[A-Z]+$/
		return reg.test(value)
	},

	/**
	 * @description 判断是否是大写字母开头
	 * @param value
	 * @returns {boolean}
	 */
	isAlphabets: function(value) {
		const reg = /^[A-Za-z]+$/
		return reg.test(value)
	},

	/**
	 * @description 判断是否是字符串
	 * @param value
	 * @returns {boolean}
	 */
	isString: function(value) {
		return typeof value === 'string' || value instanceof String
	},

	/**
	 * @description 判断是否是数组
	 * @param arg
	 */
	isArray: function(arg) {
		if (typeof Array.isArray === 'undefined') {
			return Object.prototype.toString.call(arg) === '[object Array]'
		}
		return Array.isArray(arg)
	},

	/**
	 * @description 判断是否是端口号
	 * @param value
	 * @returns {boolean}
	 */
	isPort: function(value) {
		const reg =
			/^([0-9]|[1-9]\d|[1-9]\d{2}|[1-9]\d{3}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/
		return reg.test(value)
	},

	/**
	 * @description 判断是否是手机号
	 * @param value
	 * @returns {boolean}
	 */
	isPhone: function(value) {
		const reg = /^1\d{10}$/
		return reg.test(value)
	},

	/**
	 * @description 判断是否是身份证号(第二代)
	 * @param value
	 * @returns {boolean}
	 */
	isIdCard: function(value) {
		const reg =
			/^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
		return reg.test(value)
	},

	/**
	 * @description 判断是否是邮箱
	 * @param value
	 * @returns {boolean}
	 */
	isEmail: function(value) {
		const reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
		return reg.test(value)
	},

	/**
	 * @description 判断是否中文
	 * @param value
	 * @returns {boolean}
	 */
	isChina: function(value) {
		const reg = /^[\u4E00-\u9FA5]{2,4}$/
		return reg.test(value)
	},

	/**
	 * @description 判断是否为空
	 * @param value
	 * @returns {boolean}
	 */
	isBlank: function(value) {
		return (
			value === null ||
			false ||
			value === '' ||
			value.trim() === '' ||
			value.toLocaleLowerCase().trim() === 'null'
		)
	},

	/**
	 * @description 判断是否为固话
	 * @param value
	 * @returns {boolean}
	 */
	isTel: function(value) {
		const reg =
			/^(400|800)([0-9\\-]{7,10})|(([0-9]{4}|[0-9]{3})([- ])?)?([0-9]{7,8})(([- 转])*([0-9]{1,4}))?$/
		return reg.test(value)
	},

	/**
	 * @description 判断是否为数字且最多两位小数
	 * @param value
	 * @returns {boolean}
	 */
	isNum: function(value) {
		const reg = /^\d+(\.\d{1,2})?$/
		return reg.test(value)
	},

	/**
	 * @description 判断是否为json
	 * @param value
	 * @returns {boolean}
	 */
	isJson: function(value) {
		if (typeof value === 'string') {
			const obj = JSON.parse(value)
			return !!(typeof obj === 'object' && obj)
		}
		return false
	},

	/**
	 * @description 判断是否为银行卡号
	 * @param value
	 * @returns {boolean}
	 */
	isMoneyCard: function(value) {
		const pattern = /^([1-9]{1})(\d{15}|\d{16}|\d{18})$/,
			str = value.replace(/\s+/g, "");
		return pattern.test(str)
	}

}
